<template>
    <div class="container-fluid p-3 p-md-4">
        <RouterView v-if="!isLoading && hasOrder"/>

        <div v-if="isLoading === true" class="p-5 text-center">
            <i class="fad fa-spinner fa-fw fa-spin text-primary mr-4"/> Nahrávám zakázku
        </div>

    </div>
</template>

<script>
import {mapGetters} from "vuex"

export default {

    computed: {
        ...mapGetters({
            isLoading: "worker/order/isLoading",
            hasOrder: "worker/order/hasOrder",
            order: "worker/order/getOrder",
        })
    },

    mounted() {
        this.loadOrder(this.$route.params.id)
    },

    methods: {

        loadOrder(id) {
            this.$store.dispatch("worker/order/getOrder", id)
                .catch((error) => {
                    this.errorMessage(error.response.data.message)
                })
        },

    }

}
</script>
